import * as React from "react";
const SvgChevronRight = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", overflow: "visible", preserveAspectRatio: "none", style: {
  display: "block"
}, viewBox: "0 0 18 18", ...props }, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "m7 5 4 4-4 4" }));
export default SvgChevronRight;
